import { Button } from '@chakra-ui/react';
import React, { ReactElement } from 'react';

interface IOwnProps {
  icon: ReactElement;
  value: string;
  onSelectedButton(filter: string): void;
  isSelected: boolean;
}

const ButtonFilterSelectiveProcess: React.FC<IOwnProps> = ({ icon, value, isSelected, onSelectedButton }) => {
  return (
    <Button
      leftIcon={icon}
      size="sm"
      width="100%"
      justifyContent="flex-start"
      borderRadius="md"
      fontWeight="normal"
      fontSize="sm"
      px={2}
      py={2}
      bg={isSelected ? 'blue.100 !important' : 'transparent'}
      _hover={{ bg: 'gray.50' }}
      _focus={{ bg: 'gray.100', boxShadow: 'none' }}
      onClick={() => onSelectedButton(value)}
    >
      {value}
    </Button>
  );
};

export default ButtonFilterSelectiveProcess;
